module.exports = __webpack_public_path__ + "img/kd.4cf72633.jpg";